<template>
        <div class="edits setting">
            <div class="setting-h1">
                Display Settings
            </div>
            <div class="mb-3 mt-2">
                <div class="form-check form-switch">
                <input class="form-check-input"v-model="isDarkMode" @change="toggleTheme" type="checkbox" role="switch" id="switchCheckDefault">
                <label class="form-check-label" for="switchCheckDefault">{{ isDarkMode ? 'Light Theme':'Dark Theme' }}</label>
                </div>
            </div>      
        </div>
</template>
<script>

export default {
    components:{
    },
    data(){
        return{
           isDarkMode: false       
        }
    },
    mounted(){
        let savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'dark') {
            this.isDarkMode = true;
        }else{
            this.isDarkMode = false;
        }
    },
    methods:{
        toggleTheme(){     
            if(this.isDarkMode){
                 document.body.classList.add('darkmode')
                localStorage.setItem('theme', 'dark');
            }else{
                 document.body.classList.remove('darkmode')
                localStorage.setItem('theme', 'light');
            }
         
        }
    }
    
    
    
}
</script>
<style scoped>



.edit-profile{
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    margin:4.5rem 0rem;
}

.edits{
    grid-column:2/3;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

/* Color when enabled */
.form-check-input:checked {
    background-color: var(--primary);
    border-color: var(--primary);
}

@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
}
}
</style>